import { useMemo } from 'react';
import { AstroApiClient } from '../api';
import { useHttp } from '../http';
import { runtimeConfig } from '../platform/runtime';

export const useAstroApiClient = (): AstroApiClient => {
  const http = useHttp();

  return useMemo(
    () =>
      new AstroApiClient(runtimeConfig.apiBaseUrl, {
        fetch: (url, init) => http(url, init).response,
      }),
    [http]
  );
};

export default useAstroApiClient;
